import React, {useContext, useRef} from 'react';
import PropTypes from "prop-types";
import Context from '../OriginStoryProvider';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const ToCLink = ({ number, chapter, href, category }) => {
	const { data: {content, smoother} } = useContext(Context);

	const ToCItem = useRef(null);

	const {contextSafe} = useGSAP({scope: ToCItem.current, dependencies: [content.chapters]});

	const handleClick = contextSafe((event) => {
		event.preventDefault();
		ScrollTrigger.refresh();
		smoother.scrollTo(`#${href}`, false, 'top top');
	});

	const isFocusable = (category) => {
		if (category === 'released') return "0";
		return "-1";
	}

	return (
		<li className='toc__item' ref={ToCItem}>
			<div className='toc__graphics'>
				<div className='toc__number-container'>
					<p className='toc__number'>{number}</p>
					<svg className="toc__number-bg" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="20.95" cy="20.95" r="20.95" fill="#AF1E27"/>
					</svg>
				</div>
				<svg className='toc__arrow' width="50" height="24" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clipPath="url(#clip0_144_334)">
						<path d="M49.3281 11.9394C46.2569 13.3344 43.4301 15.023 40.8475 17.0038C38.265 18.9847 35.8984 21.2853 33.7505 23.903C33.7676 21.7678 34.1326 19.7732 34.8429 17.9205C35.5532 16.0692 36.6001 14.3586 37.9851 12.7913H32.2462C27.3283 12.7913 23.7428 13.5536 21.4884 15.0781C19.2341 16.6027 17.9641 19.0881 17.68 22.5328L0.328125 22.5328C0.576719 19.9661 1.35375 17.8213 2.65781 16.0982C3.96328 14.3765 5.87532 12.9884 8.39677 11.938C5.85827 10.8876 3.93203 9.5009 2.61803 7.77783C1.30403 6.05613 0.541206 3.91953 0.328125 1.37076L17.68 1.37076C17.9641 4.8169 19.2326 7.30088 21.4884 8.82545C23.7428 10.35 27.3297 11.1123 32.2462 11.1123H37.9851C36.6001 9.52709 35.5532 7.81367 34.8429 5.97067C34.1326 4.12767 33.769 2.13718 33.7505 0.00195312C35.9168 2.63756 38.2863 4.94234 40.8603 6.91491C43.4343 8.88748 46.2569 10.5623 49.3281 11.9408V11.9394Z" fill="#B2A98D"/>
					</g>
					<defs>
						<clipPath id="clip0_144_334">
							<rect width="49" height="23.9024" fill="white" transform="translate(0.328125)"/>
						</clipPath>
					</defs>
				</svg>
			</div>
			<h3 className='toc__chapter h4'><a 
				className="toc__link" 
				href='#' 
				onClick={handleClick}
				tabIndex={isFocusable(category)}
			>{chapter}</a></h3>
		</li>

	)
}

export default ToCLink;

ToCLink.propTypes = {
	chapter: PropTypes.string.isRequired,
	number: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	category: PropTypes.string.isRequired,
}